import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section containing filters
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    // Data feed function for provider selection
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'ProductId',
                            localId: 'product:combo',
                            label: _('Producto'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    // Data feed function for product selection
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: countries,
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: countries,
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        {
                            view: 'richselect',
                            name: 'Type',
                            localId: 'provider:combo',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'N', value: _('Normal') },
                                { id: 'FS', value: _('FreeSpin') },
                                { id: 'FC', value: _('FreeCash') },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'ValueMinimum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'),
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'checkbox',
                            label: _('Resumen por Proveedor'),
                            labelPosition: 'top',
                            name: 'IsDetails',
                            id: 'IsDetails',
                            value: 1,
                        },
                        { gravity: 1, id: 'grav' },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    id: 'Sort',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Sort',
                            label: _('Ordenar por'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Fecha') },
                                { id: '2', value: _('Usuario') },
                                { id: '3', value: _('Apuestas') },
                                { id: '4', value: _('Premios') },
                            ],
                            value: '1',
                        },
                        {
                            view: 'combo',
                            name: 'Dir',
                            label: _('Orden'),
                            labelPosition: 'top',
                            options: [
                                { id: '0', value: _('Ascendente') },
                                { id: '1', value: _('Descendente') },
                            ],
                            value: '0',
                        },
                        {
                            view: 'text',
                            name: 'Identifier',
                            label: _('Identificador'),
                            labelPosition: 'top',
                            placeholder: _('Identificador'),
                        },
                        { gravity: 1, id: 'grav2' },
                    ],
                },
            ],
        };

        // Upper section containing the left filters
        const upper_section = {
            css: 'father-container',
            id: 'father-container',
            height: document.body.offsetWidth < 500 ? 510 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { gravity: 1, id: 'grav3' },
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Clear form values
                                $$('myForm').setValues($$('myForm').getCleanValues());
                                $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Gather filter data and trigger report
                                const filterdata = this.getRoot().getValues();
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry;
                                }
                                delete filterdata['CountrySelect2'];
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date'];
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker'];
                                    }
                                }
                                this.app.callEvent('casinoReport:filter', [filterdata]);
                                $$('b5').collapse();
                                $$('a5').scrollTo(100, 0);
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section containing filters and buttons
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section2],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        $$('Sort').hide();
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            // Show/hide sorting options based on checkbox state
            if ($$('IsDetails').getValue() == '1') {
                if (screen.width < 500) {
                    $$('father-container').define('height', 510);
                }
                $$('Sort').hide();
            } else {
                if (screen.width < 500) {
                    $$('father-container').define('height', 700);
                }
                $$('Sort').show();
            }
        });

        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Set date modal language after rendering
            devConfig.setDateModal(lang);
        });

        webix.ready(function () {
            // Adjust visibility of elements based on screen size
            if (screen.width < 500) {
                $$('grav').hide();
                $$('grav2').hide();
                $$('grav3').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });
    }
}

// FILE DOCUMENTED
